import { Injectable } from '@angular/core';
import { AppConstants } from '../common/app.constants'
import { StorageService } from '../common/services/storage.service';


@Injectable({
    providedIn: 'root'
})
export class PermissionService {



    pagePermissionMaping: any[] = [
        { page: "department-edit", parent: "department" },
        { page: "shop-edit", parent: "shop" },
        { page: "region-edit", parent: "region" },
        { page: "kitchen-edit", parent: "kitchen" },
        { page: "uom-edit", parent: "uom" },
        { page: "reason-edit", parent: "reason" },
        { page: "menu-edit", parent: "menu" },
        { page: "employee-category-edit", parent: "employee-category" },
        { page: "employee-job-position-edit", parent: "employee" },
        { page: "employee-job-title-edit", parent: "employee" },
        { page: "employee-status-edit", parent: "employee" },
        { page: "employee-job-position", parent: "employee" },
        { page: "employee-job-title", parent: "employee" },
        { page: "employee-status", parent: "employee" },
        { page: "employee-edit", parent: "employee" },
        { page: "employee-ext", parent: "employee" },
        { page: "employee-ext-edit", parent: "employee" },
        { page: "expense-edit", parent: "expense" },
        { page: "expense-type-edit", parent: "expense-type" },
        { page: "item-class-edit", parent: "item-class" },
        { page: "sale-item-edit", parent: "sale-item" },
        { page: "sale-item-bulk-update", parent: "sale-item" },
        { page: "stock-category-edit", parent: "stock-category" },
        { page: "stocks-edit", parent: "stocks" },
        { page: "station-edit", parent: "station" },
        { page: "kitchen-edit", parent: "kitchen" },
        { page: "user-edit", parent: "user" },
        { page: "user-group-edit", parent: "user-group" },
        { page: "voucher-edit", parent: "voucher" },
        { page: "customization-edit", parent: "customization" },
        { page: "payroll-group-edit", parent: "payroll-group" },
        { page: "shop-payroll-setting-edit", parent: "shop-payroll-setting" },
        { page: "staff-payroll-group-edit", parent: "staff-payroll-group" },
        { page: "combo-edit", parent: "combo" },
        { page: "discount-edit", parent: "discount" },
        { page: "auto-discount", parent: "discount" },
        { page: "auto-discount-edit", parent: "auto-discount" },
        { page: "item-class-display-order", parent: "item-class" },
        { page: "sale-item-display-order", parent: "sale-item" },
        { page: "hot-item-display-order", parent: "sale-item" },
        { page: "item-discount-display-order", parent: "discount" },
        { page: "expense-type", parent: "expense" },
        { page: "menu-item", parent: "custom-menu" },
        { page: "order-summary", parent: "orders" },
        { page: "ads-setting-edit", parent: "ads-setting" },
        { page: "master-sales-report-cost", parent: "master-sales-report" },
        { page: "weekly-result-by-store-view", parent: "weekly-result-by-store" },
        { page: "ytd-result-by-store-view", parent: "ytd-result-by-store" },
        { page: "weekly-result-by-branch-view", parent: "weekly-result-by-branch" },
        { page: "ytd-result-by-branch-view", parent: "ytd-result-by-branch" },
        { page: "updated-shop-list", parent: "updater" },
        { page: "daily_sales", parent: "daily-sales-summary" }

    ];



    constructor(private storageService: StorageService) { }


    /**
     * Returns the page permission for currenmtly loged in user
     * @param page 
     * @returns 
     */
    getPagePermission(page: string): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const users = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        const permissionArr = users.permissions;
        const pagePermission = permissionArr.find((perm: any) => perm.page == page);
        return (pagePermission) ? pagePermission.permission : this.getDefaultPermission(page);
        // return {
        //     "can_view": 1,
        //     "can_add": 1,
        //     "can_edit": 1,
        //     "can_delete": 1,
        //     "can_execute": 1,
        //     "can_publish": 1,
        //     "can_export": 1,
        //     "can_import": 1,

        // };
    }

    getRowPermission(pagePermission: any, rowId: any): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const user = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        let rowPermission = JSON.parse(JSON.stringify(pagePermission));
        if (user.user_type == 'SHOP' && (rowId < AppConstants.MASTER_ID_MULTI_FACTOR && rowId > 0)) {
            rowPermission.can_edit = 0;
            rowPermission.can_delete = 0;
        }
        return rowPermission;
    }
    /**
     * Returns the list of permissions for the currently logged in user
     * @returns 
     */

    getPermission(): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const users = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        const permissionArr = users.permissions;
        return permissionArr;
    }

    /**
     * Returns the currently logged in user info
     * @returns 
     */
    getCurrentUser(): any {
        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        return (sesUser !== null) ? JSON.parse(sesUser) : { id: 0, user_type: '' };
    }

    /**
     * The default permission is to view the content
     * @returns 
     */
    getDefaultPermission(page: string): any {
        var permission: any = {
            "can_view": 0,
            "can_add": 0,
            "can_edit": 0,
            "can_delete": 0,
            "can_execute": 0,
            "can_publish": 0,
            "can_export": 0,
            "can_import": 0,

        }

        const parentPage = this.pagePermissionMaping.find((pg: any) => pg.page == page && pg.parent !== page);
        if (parentPage) {
            permission = this.getPagePermission(parentPage.parent);
        }
        return permission;
    }

    /**
     * Returns the permission set for the action
     * @param page 
     * @param action 
     * @returns 
     */
    hasPermission(page: string, action: string): boolean {

        const permission = this.getPagePermission(page);

        var hasPermission = 0;
        switch (action) {
            case 'view':
                hasPermission = permission.can_view;
                break;
            case 'add':
                hasPermission = permission.can_add;
                break;
            case 'edit':
                hasPermission = permission.can_edit;
                break;
            case 'delete':
                hasPermission = permission.can_delete;
                break;
            case 'execute':
                hasPermission = permission.can_execute;
                break;
            case 'publish':
                hasPermission = permission.can_publish;
                break;
            case 'export':
                hasPermission = permission.can_export;
                break;
        }
        return (hasPermission == 1) ? true : false;
        // return true;

    }

    /**
     * Modify and filter permissions before setting to session storage
     */
    validatePermission(user: any): any {
        if (!user || !user.permissions) return user;

        const userType = user.user_type;

        // 1. Convert permissions to a working array (handles PHP's associative array vs standard array)
        let permissionsArr = Array.isArray(user.permissions) ? user.permissions : Object.values(user.permissions);

        // 2. Filter permissions based on the 'available_in' user type list
        permissionsArr = permissionsArr.filter((permObj: any) => {
            // Skip the index-0 empty array often found in this backend's response
            if (Array.isArray(permObj) && permObj.length === 0) return false;

            if (permObj && permObj.page && Array.isArray(permObj.available_in)) {
                return permObj.available_in.includes(userType);
            }
            // If it's a valid permission object but missing available_in, keep it by default unless it's definitely invalid
            return !!(permObj && permObj.page);
        });

        // 3. For non-HQ users (SHOP, AREA_MANAGER), strip certain rights based on allowed_list
        if (userType !== 'HQ') {
            const restrictedPages: any[] = [
                { page: 'sale-item', can_add: 0, can_edit: 1, can_delete: 1 },
                { page: 'item-class', can_add: 0, can_edit: 1, can_delete: 1 },
                { page: 'combo', can_add: 0, can_edit: 1, can_delete: 1 },
                { page: 'customization', can_add: 0, can_edit: 1, can_delete: 1 }
            ];

            permissionsArr.forEach((permObj: any) => {
                if (permObj.permission) {
                    const allowedPage = restrictedPages.find(p => p.page === permObj.page);
                    if (!allowedPage) {
                        // permObj.permission.can_add = 0;
                        // permObj.permission.can_edit = 0;
                        // permObj.permission.can_delete = 0;
                    } else {
                        if (allowedPage.can_add !== undefined) permObj.permission.can_add = (allowedPage.can_add && permObj.permission.can_add) ? 1 : 0;
                        if (allowedPage.can_edit !== undefined) permObj.permission.can_edit = (allowedPage.can_edit && permObj.permission.can_edit) ? 1 : 0;
                        if (allowedPage.can_delete !== undefined) permObj.permission.can_delete = (allowedPage.can_delete && permObj.permission.can_delete) ? 1 : 0;
                    }
                }
            });
        }

        user.permissions = permissionsArr;
        return user;
    }

}
